/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { sendDeviceAlertRequestSchema } from "./sendDeviceAlertRequestSchema.ts";

export const deviceSendAlertCreateStatus200Schema = z.any();

export const deviceSendAlertCreateResponseSchema = deviceSendAlertCreateStatus200Schema;

export const deviceSendAlertCreateDataSchemaJson = sendDeviceAlertRequestSchema;

export const deviceSendAlertCreateDataSchemaXml = sendDeviceAlertRequestSchema;

export const deviceSendAlertCreateDataSchema = z.union([deviceSendAlertCreateDataSchemaJson, deviceSendAlertCreateDataSchemaXml]);
